<template>
  <v-card style="top: 50px">
    <v-card-title primary-title>
      <div>
        <h1>Е.Комтранс</h1>
        <p></p>
        <p>Транспортно-экспедиторская Компания Е.Комтранс оказывает полный спектр услуг по перевозке грузов автомобильным и морским транспортом как на территории России, так и за ее пределами. Высокий профессионализм наших сотрудников позволяет выполнять заказы точно в срок и с достойным качеством сервиса.</p>
        <p>Кроме того мы имеем долгосрочные отношения с многочисленными российскими и зарубежными партнерами что позволяет нам удовлетворять любые потребности Клиентов, связанные с доставкой грузов «от двери до двери».</p>
        <p>Работа с нами это:</p>
        <ul>
          <li><b>стабильность:</b> обусловленная наличием надежных партнеров;</li>
          <li><b>оперативность:</b> подача необходимого транспортного средства в кратчайшие сроки;</li>
          <li><b>высоко-квалифицированный персонал:</b> позволяет разработать оптимальный маршрут следования, определить реальные сроки доставки, дать четкие инструкции водителю-экспедитору;</li>
          <li><b>безопасность:</b> застрахованная ответственность экспедитора (USD 100,000)</li>
          <li><b>удобство:</b> заявка может быть подана в устной форме, возможна работа в выходные дни</li>
        </ul>
      </div>
      <carousel-3d
        :controls-visible="true"
        autoplay
        :clickable="true"
      >
      <slide :index="0">
        <img :src="require('@/assets/o1.jpg')">
      </slide>
        <slide :index="1">
        <img :src="require('@/assets/o2.jpg')">
      </slide>
        <slide :index="2">
        <img :src="require('@/assets/o3.jpg')">
      </slide>
        <slide :index="3">
        <img :src="require('@/assets/o4.jpg')">
      </slide>
        <slide :index="4">
        <img :src="require('@/assets/o5.jpg')">
      </slide>
      </carousel-3d>
    </v-card-title>
  </v-card>
</template>

<script>

import {Carousel3d, Slide} from 'vue-carousel-3d'

export default {
  components: {
    Carousel3d,
    Slide
  }

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/about.vue